module.exports = __webpack_public_path__ + "assets/img/news-head.380fb0aa.png";